module.exports = __webpack_public_path__ + "./fonts/PingFang-SC-Regular.ttf";